import { useMemo, useState } from "react";
import { ShoppingCart, Smartphone, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { OrderLink } from "./OrderLink";

const selectCls = "w-full bg-[#FAF9F6] border border-[#D1CFC7] focus:border-[#2C402E] px-3 py-3 outline-none font-body text-sm";

export const PaperOrderDialog = ({ open, onOpenChange, points, paper, digital, refs, common }) => {
  const cities = useMemo(() => [...new Set(points.map((p) => p.city))], [points]);
  const [city, setCity] = useState("");
  const [pickup, setPickup] = useState("");
  const shops = points.filter((p) => p.city === city);
  const chosenShop = shops.length === 1 ? shops[0].name : pickup;
  const ready = points.length === 0 || (city && chosenShop);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="paper-order-dialog" className="bg-[#FAF9F6] rounded-none border-[#D1CFC7] max-w-md w-[calc(100%-2rem)]">
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2 font-serif text-2xl font-light text-[#1A1A1A]"><ShoppingCart size={18} className="text-[#9E4735]" /> Choix de votre ville de retrait</DialogTitle>
          <DialogDescription className="font-body text-sm text-[#4A4A4A] text-left">Livre papier — {paper.price}</DialogDescription>
        </DialogHeader>
        {points.length > 0 ? (
          <div className="space-y-3">
            <label className="text-xs font-body text-[#4A4A4A] block">Sélectionnez votre ville :</label>
            <select value={city} onChange={(e) => { setCity(e.target.value); setPickup(""); }} data-testid="paper-city-select" className={selectCls}>
              <option value="">— Choisir —</option>
              {cities.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
            {shops.length > 1 && (
              <select value={pickup} onChange={(e) => setPickup(e.target.value)} data-testid="paper-pickup-select" className={selectCls}>
                <option value="">— Choisir le point de retrait —</option>
                {shops.map((s) => <option key={s.id} value={s.name}>{s.name}{s.kind === "pick_read" ? " (Pick & Read)" : ""}</option>)}
              </select>
            )}
            {shops.length === 1 && <p data-testid="paper-pickup-single" className="text-xs font-body text-[#2C402E]">Retrait : {shops[0].name}{shops[0].kind === "pick_read" ? " (relais Pick & Read)" : ""}{shops[0].address ? ` — ${shops[0].address}` : ""}</p>}
          </div>
        ) : (
          <p className="text-sm font-body text-[#4A4A4A]">Indiquez votre ville dans la conversation WhatsApp, nous vous proposerons le point de retrait le plus proche.</p>
        )}
        <OrderLink {...common} version={paper} orderRef={refs.papier} extra={{ city, pickup: chosenShop }} disabled={!ready} testid="paper-order-confirm"
          className={`flex items-center justify-center gap-3 py-3.5 font-body text-sm tracking-wide transition-colors ${ready ? "bg-[#2C402E] hover:bg-[#1F2D21] text-[#FAF9F6]" : "bg-[#D1CFC7] text-[#757575] pointer-events-none"}`}>
          <MessageCircle size={16} /> Confirmer ma commande sur WhatsApp
        </OrderLink>
        {digital && (
          <div data-testid="paper-switch-digital" className="border-t border-[#D1CFC7] pt-4 mt-2">
            <p className="text-[10px] tracking-[0.25em] uppercase text-[#9E4735] font-body mb-2">Votre ville n'est pas dans la liste&nbsp;?</p>
            <OrderLink {...common} version={digital} orderRef={refs.numerique} testid="paper-switch-digital-button" className="flex items-center justify-center gap-2 border border-[#2C402E] text-[#2C402E] hover:bg-[#2C402E] hover:text-[#FAF9F6] py-3 font-body text-sm transition-colors">
              <Smartphone size={14} /> Changer pour la version numérique ({digital.price})
            </OrderLink>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
